import React from 'react';
import { Divider } from 'antd';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import styles from './index.module.scss';

const socialLinks = [
  {
    href: 'https://www.facebook.com/profile.php?id=61576325549165',
    imgSrc: '/media/social/facebook.svg',
    label: 'Facebook',
  },
  { href: 'https://www.instagram.com/tippingguide/', imgSrc: '/media/social/instagram.svg', label: 'Instagram' },
  { href: 'https://x.com/TippingGuide_', imgSrc: '/media/social/twitter.svg', label: 'Twitter' },
  {
    href: 'https://www.linkedin.com/company/tipping-guide/about/',
    imgSrc: '/media/social/linkedin.svg',
    label: 'LinkedIn',
  },
  {
    href: 'https://www.youtube.com/@TippingGuide',
    imgSrc: '/media/social/youtube.svg',
    label: 'youtube',
  },
];

const footerLinks = [
  {
    title: 'Pages',
    links: [
      { to: '/', label: 'Home' },
      { to: '/categories', label: 'Tipping Categories' },
      { to: '/share-your-two-cents', label: 'Share Your Two Cents' },
      { to: '/tip-calculator', label: 'Tip Calculator' },
      { to: '/tipping-articles', label: 'Articles' },
    ],
  },
  {
    title: 'Contact Us',
    links: [
      { to: '/contact-us', label: 'Contact Us' },
      // { to: '/', label: 'Support' },
      { to: '/privacy-policy', label: 'Privacy Policy' },
      { to: '/terms-and-conditions', label: 'Terms & Conditions' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { to: '/our-mission', label: 'Our Mission' },
      { to: '/', label: 'International Community' },
      { to: '/faq', label: 'FAQ' },
    ],
  },
];

export default function FooterContent(): React.ReactElement {
  const isTablet = useMediaQuery({ query: '(max-width: 1024px)' });
  const location = useLocation();

  return (
    <div className={styles.footerContent}>
      <div className={styles.content}>
        <div className={styles.info}>
          <NavLink to="/">
            <img src="/logo.svg" className={styles.logoSvg} alt="Tipping" />
          </NavLink>
          <div>
            <div className={styles.social}>
              {socialLinks.map(({ href, imgSrc, label }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={imgSrc} alt={label} />
                </a>
              ))}
            </div>
            <span>
              Explore key resources, connect with us, and stay
              <br />
              updated by visiting our quick links and following us on
              <br />
              social media.
            </span>
          </div>
        </div>
        <div className={styles.items}>
          {footerLinks
            .filter(
              ({ title }) => !(isTablet && (title === 'Pages' || title === 'Resources')),
            )
            .map(({ title, links }) => (
              <div key={title} className={styles.item}>
                {isTablet ? null : <span>{title}</span>}
                <div className={styles.links}>
                  {links.map(({ to, label }) => (
                    <NavLink
                      key={label}
                      to={to}
                      className={styles.link}
                      style={location.pathname === to && title === 'Contact Us' ? { color: '#11B559' } : {}}
                    >
                      {label}
                    </NavLink>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </div>
      <div>
        <Divider style={{ borderColor: '#FFFFFF4D', margin: '16px 0' }} />
        <div className={styles.rights}>
          @{new Date().getFullYear()} tippingguide.com All rights reserved.
        </div>
      </div>
    </div>
  );
}
